// jshint maxerr:100
import Vue from 'vue'
import Vuex from 'vuex'
import i18n from '../i18n.js'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
    w: window.innerWidth,
    H: window.innerHeight,
    countries: {
      country: null,
      all: {
        DZ: {
          name_ar: 'الجزائر ☪',
          name_en: 'Algeria'
        },
        PS: {
          name_ar: 'فلسطين ❤',
          name_en: 'Palestinian Territory, Occupied'
        },
        CN: {
          name_ar: 'الصين',
          name_en: 'China'
        },
        IT: {
          name_ar: 'إيطاليا',
          name_en: 'Italy'
        },
        ES: {
          name_ar: 'إسبانيا',
          name_en: 'Spain'
        },
        DE: {
          name_ar: 'ألمانيا',
          name_en: 'Germany'
        },
        IR: {
          name_ar: 'إيران',
          name_en: 'Iran'
        },
        US: {
          name_ar: 'الولايات المتحدة الأمريكية',
          name_en: 'USA'
        },
        FR: {
          name_ar: 'فرنسا',
          name_en: 'France'
        },
        KR: {
          name_ar: 'كوريا الجنوبية',
          name_en: 'Korea, South'
        },
        CH: {
          name_ar: 'سويسرا',
          name_en: 'Switzerland'
        },
        GB: {
          name_ar: 'المملكة المتحدة',
          name_en: 'UK'
        },
        NL: {
          name_ar: 'هولندا',
          name_en: 'Netherlands'
        },
        BE: {
          name_ar: 'بلجيكا',
          name_en: 'Belgium'
        },
        AT: {
          name_ar: 'النمسا',
          name_en: 'Austria'
        },
        NO: {
          name_ar: 'النرويج',
          name_en: 'Norway'
        },
        SE: {
          name_ar: 'السويد',
          name_en: 'Sweden'
        },
        DK: {
          name_ar: 'الدانمرك',
          name_en: 'Denmark'
        },
        PT: {
          name_ar: 'البرتغال',
          name_en: 'Portugal'
        },
        MY: {
          name_ar: 'ماليزيا',
          name_en: 'Malaysia'
        },
        CA: {
          name_ar: 'كندا',
          name_en: 'Canada'
        },
        AU: {
          name_ar: 'أستراليا',
          name_en: 'Australia'
        },
        JP: {
          name_ar: 'اليابان',
          name_en: 'Japan'
        },
        BR: {
          name_ar: 'البرازيل',
          name_en: 'Brazil'
        },
        CZ: {
          name_ar: 'جمهورية التشيك',
          name_en: 'Czech Republic'
        },
        IE: {
          name_ar: 'أيرلندا',
          name_en: 'Ireland'
        },
        TR: {
          name_ar: 'تركيا',
          name_en: 'Turkey'
        },
        LU: {
          name_ar: 'لوكسمبورغ',
          name_en: 'Luxembourg'
        },
        PK: {
          name_ar: 'باكستان',
          name_en: 'Pakistan'
        },
        FI: {
          name_ar: 'فنلندا',
          name_en: 'Finland'
        },
        GR: {
          name_ar: 'اليونان',
          name_en: 'Greece'
        },
        IS: {
          name_ar: 'أيسلندا',
          name_en: 'Iceland'
        },
        QA: {
          name_ar: 'قطر',
          name_en: 'Qatar'
        },
        PL: {
          name_ar: 'بولندا',
          name_en: 'Poland'
        },
        ID: {
          name_ar: 'أندونيسيا',
          name_en: 'Indonesia'
        },
        CL: {
          name_ar: 'شيلي',
          name_en: 'Chile'
        },
        SG: {
          name_ar: 'سنغافورة',
          name_en: 'Singapore'
        },
        EC: {
          name_ar: 'الإكوادور',
          name_en: 'Ecuador'
        },
        TH: {
          name_ar: 'تايلاند',
          name_en: 'Thailand'
        },
        RO: {
          name_ar: 'رومانيا',
          name_en: 'Romania'
        },
        SA: {
          name_ar: 'السعودية',
          name_en: 'Saudi Arabia'
        },
        SI: {
          name_ar: 'سلوفينيا',
          name_en: 'Slovenia'
        },
        PH: {
          name_ar: 'الفلبين',
          name_en: 'Philippines'
        },
        EE: {
          name_ar: 'أستونيا',
          name_en: 'Estonia'
        },
        BH: {
          name_ar: 'البحرين',
          name_en: 'Bahrain'
        },
        EG: {
          name_ar: 'مصر',
          name_en: 'Egypt'
        },
        IN: {
          name_ar: 'الهند',
          name_en: 'India'
        },
        HK: {
          name_ar: 'هونغ كونغ الصينية',
          name_en: 'Hong Kong'
        },
        PE: {
          name_ar: 'بيرو',
          name_en: 'Peru'
        },
        RU: {
          name_ar: 'روسيا',
          name_en: 'Russia'
        },
        ZA: {
          name_ar: 'جنوب أفريقيا',
          name_en: 'South Africa'
        },
        IQ: {
          name_ar: 'العراق',
          name_en: 'Iraq'
        },
        MX: {
          name_ar: 'المكسيك',
          name_en: 'Mexico'
        },
        PA: {
          name_ar: 'بنما',
          name_en: 'Panama'
        },
        LB: {
          name_ar: 'لبنان',
          name_en: 'Lebanon'
        },
        KW: {
          name_ar: 'الكويت',
          name_en: 'Kuwait'
        },
        HR: {
          name_ar: 'كرواتيا',
          name_en: 'Croatia'
        },
        AM: {
          name_ar: 'أرمينيا',
          name_en: 'Armenia'
        },
        AR: {
          name_ar: 'الأرجنتين',
          name_en: 'Argentina'
        },
        CO: {
          name_ar: 'كولومبيا',
          name_en: 'Colombia'
        },
        TW: {
          name_ar: 'تايوان',
          name_en: 'Taiwan'
        },
        SM: {
          name_ar: 'سان مارينو',
          name_en: 'San Marino'
        },
        BG: {
          name_ar: 'بلغاريا',
          name_en: 'Bulgaria'
        },
        AE: {
          name_ar: 'الإمارات',
          name_en: 'United Arab Emirates'
        },
        SK: {
          name_ar: 'سلوفاكيا',
          name_en: 'Slovakia'
        },
        LV: {
          name_ar: 'لاتفيا',
          name_en: 'Latvia'
        },
        CR: {
          name_ar: 'كوستاريكا',
          name_en: 'Costa Rica'
        },
        UY: {
          name_ar: 'أورغواي',
          name_en: 'Uruguay'
        },
        HU: {
          name_ar: 'هنغاريا',
          name_en: 'Hungary'
        },
        VN: {
          name_ar: 'فيتنام',
          name_en: 'Vietnam'
        },
        FO: {
          name_ar: 'جزر فارو',
          name_en: 'Faroe Islands'
        },
        BA: {
          name_ar: 'البوسنة والهرسك',
          name_en: 'Bosnia Herzegovina'
        },
        AD: {
          name_ar: 'أندورا',
          name_en: 'Andorra'
        },
        MA: {
          name_ar: 'المغرب',
          name_en: 'Morocco'
        },
        JO: {
          name_ar: 'الأردن',
          name_en: 'Jordan'
        },
        BN: {
          name_ar: 'بروناي',
          name_en: 'Brunei'
        },
        MK: {
          name_ar: 'مقدونيا',
          name_en: 'Macedonia'
        },
        AL: {
          name_ar: 'ألبانيا',
          name_en: 'Albania'
        },
        LK: {
          name_ar: 'سريلانكا',
          name_en: 'Sri Lanka'
        },
        CY: {
          name_ar: 'قبرص',
          name_en: 'Cyprus'
        },
        MT: {
          name_ar: 'مالطا',
          name_en: 'Malta'
        },
        DO: {
          name_ar: 'جمهورية الدومينيك',
          name_en: 'Dominican Republic'
        },
        LT: {
          name_ar: 'ليتوانيا',
          name_en: 'Lithuania'
        },
        BY: {
          name_ar: 'روسيا البيضاء',
          name_en: 'Belarus'
        },
        MD: {
          name_ar: 'مولدافيا',
          name_en: 'Moldova'
        },
        VE: {
          name_ar: 'فنزويلا',
          name_en: 'Venezuela'
        },
        BF: {
          name_ar: 'بوركينا فاسو',
          name_en: 'Burkina Faso'
        },
        TN: {
          name_ar: 'تونس',
          name_en: 'Tunisia'
        },
        KZ: {
          name_ar: 'كازاخستان',
          name_en: 'Kazakhstan'
        },
        NZ: {
          name_ar: 'نيوزيلاندا',
          name_en: 'New Zealand'
        },
        OM: {
          name_ar: 'عُمان',
          name_en: 'Oman'
        },
        KH: {
          name_ar: 'كمبوديا',
          name_en: 'Cambodia'
        },
        GE: {
          name_ar: 'جورجيا',
          name_en: 'Georgia'
        },
        SN: {
          name_ar: 'السنغال',
          name_en: 'Senegal'
        },
        AZ: {
          name_ar: 'أذربيجان',
          name_en: 'Azerbaijan'
        },
        UA: {
          name_ar: 'أوكرانيا',
          name_en: 'Ukraine'
        },
        LI: {
          name_ar: 'ليختنشتاين',
          name_en: 'Liechtenstein'
        },
        UZ: {
          name_ar: 'أوزبكستان',
          name_en: 'Uzbekistan'
        },
        CM: {
          name_ar: 'الكاميرون',
          name_en: 'Cameroon'
        },
        BD: {
          name_ar: 'بنجلاديش',
          name_en: 'Bangladesh'
        },
        AF: {
          name_ar: 'أفغانستان',
          name_en: 'Afghanistan'
        },
        HN: {
          name_ar: 'هندوراس',
          name_en: 'Honduras'
        },
        CU: {
          name_ar: 'كوبا',
          name_en: 'Cuba'
        },
        JM: {
          name_ar: 'جامايكا',
          name_en: 'Jamaica'
        },
        BO: {
          name_ar: 'بوليفيا',
          name_en: 'Bolivia'
        },
        GH: {
          name_ar: 'غانا',
          name_en: 'Ghana'
        },
        PY: {
          name_ar: 'باراغواي',
          name_en: 'Paraguay'
        },
        MO: {
          name_ar: 'مكاو الصينية',
          name_en: 'Macau'
        },
        RW: {
          name_ar: 'رواندا',
          name_en: 'Rwanda'
        },
        GF: {
          name_ar: 'غويانا الفرنسية',
          name_en: 'French Guiana'
        },
        PF: {
          name_ar: 'بولينيزيا الفرنسية',
          name_en: 'French Polynesia'
        },
        GU: {
          name_ar: 'غوام',
          name_en: 'Guam'
        },
        MU: {
          name_ar: 'موريشيوس',
          name_en: 'Mauritius'
        },
        CI: {
          name_ar: 'ساحل العاج',
          name_en: 'Ivory Coast'
        },
        KG: {
          name_ar: 'قرغيزستان',
          name_en: 'Kyrgyzstan'
        },
        ME: {
          name_ar: 'الجبل الأسود',
          name_en: 'Montenegro'
        },
        PR: {
          name_ar: 'بورتوريكو',
          name_en: 'Puerto Rico'
        },
        GT: {
          name_ar: 'غواتيمالا',
          name_en: 'Guatemala'
        },
        MV: {
          name_ar: 'جزر المالديف',
          name_en: 'Maldives'
        },
        NG: {
          name_ar: 'نيجيريا',
          name_en: 'Nigeria'
        },
        MC: {
          name_ar: 'موناكو',
          name_en: 'Monaco'
        },
        GI: {
          name_ar: 'جبل طارق',
          name_en: 'Gibraltar'
        },
        MN: {
          name_ar: 'منغوليا',
          name_en: 'Mongolia'
        },
        ET: {
          name_ar: 'إثيوبيا',
          name_en: 'Ethiopia'
        },
        TG: {
          name_ar: 'توجو',
          name_en: 'Togo'
        },
        TT: {
          name_ar: 'ترينيداد وتوباغو',
          name_en: 'Trinidad And Tobago'
        },
        KE: {
          name_ar: 'كينيا',
          name_en: 'Kenya'
        },
        SC: {
          name_ar: 'سيشل',
          name_en: 'Seychelles'
        },
        BB: {
          name_ar: 'بربادوس',
          name_en: 'Barbados'
        },
        GQ: {
          name_ar: 'غينيا الإستوائية',
          name_en: 'Equatorial Guinea'
        },
        TZ: {
          name_ar: 'تانزانيا',
          name_en: 'Tanzania'
        },
        VI: {
          name_ar: 'جزر فرجين الأمريكية',
          name_en: 'U.S. Virgin Islands'
        },
        GY: {
          name_ar: 'غيانا',
          name_en: 'Guyana'
        },
        AW: {
          name_ar: 'آروبا',
          name_en: 'Aruba'
        },
        GA: {
          name_ar: 'الجابون',
          name_en: 'Gabon'
        },
        BS: {
          name_ar: 'الباهاما',
          name_en: 'Bahamas'
        },
        NC: {
          name_ar: 'كاليدونيا الجديدة',
          name_en: 'New Caledonia'
        },
        MF: {
          name_ar: 'سانت مارتن',
          name_en: 'Saint Martin'
        },
        SR: {
          name_ar: 'سورينام',
          name_en: 'Suriname'
        },
        KY: {
          name_ar: 'جزر الكايمن',
          name_en: 'Cayman Islands'
        },
        CW: {
          name_ar: 'كوراساو',
          name_en: 'Curacao'
        },
        CG: {
          name_ar: 'الكونغو - برازافيل',
          name_en: 'Republic of the Congo'
        },
        SV: {
          name_ar: 'السلفادور',
          name_en: 'El Salvador'
        },
        LR: {
          name_ar: 'ليبيريا',
          name_en: 'Liberia'
        },
        MG: {
          name_ar: 'مدغشقر',
          name_en: 'Madagascar'
        },
        NA: {
          name_ar: 'ناميبيا',
          name_en: 'Namibia'
        },
        ZW: {
          name_ar: 'زيمبابوي',
          name_en: 'Zimbabwe'
        },
        SD: {
          name_ar: 'السودان',
          name_en: 'Sudan'
        },
        AO: {
          name_ar: 'أنغولا',
          name_en: 'Angola'
        },
        BJ: {
          name_ar: 'بنين',
          name_en: 'Benin'
        },
        BM: {
          name_ar: 'برمودا',
          name_en: 'Bermuda'
        },
        BT: {
          name_ar: 'بوتان',
          name_en: 'Bhutan'
        },
        FJ: {
          name_ar: 'فيجي',
          name_en: 'Fiji'
        },
        GL: {
          name_ar: 'غرينلاند',
          name_en: 'Greenland'
        },
        GN: {
          name_ar: 'غينيا',
          name_en: 'Guinea'
        },
        HT: {
          name_ar: 'هايتي',
          name_en: 'Haiti'
        },
        IM: {
          name_ar: 'جزيرة مان',
          name_en: 'Isle of Man'
        },
        MR: {
          name_ar: 'موريتانيا',
          name_en: 'Mauritania'
        },
        NI: {
          name_ar: 'نيكاراغوا',
          name_en: 'Nicaragua'
        },
        LC: {
          name_ar: 'سانت لوسيا',
          name_en: 'st lucia'
        },
        ZM: {
          name_ar: 'زامبيا',
          name_en: 'Zambia'
        },
        NP: {
          name_ar: 'نيبال',
          name_en: 'Nepal'
        },
        AG: {
          name_ar: 'أنتيغوا وبربودا',
          name_en: 'Antigua and Barbuda'
        },
        CV: {
          name_ar: 'الرأس الأخضر',
          name_en: 'Cape Verde'
        },
        TD: {
          name_ar: 'تشاد',
          name_en: 'Chad'
        },
        DJ: {
          name_ar: 'جيبوتي',
          name_en: 'Djibouti'
        },
        GM: {
          name_ar: 'غامبيا',
          name_en: 'Gambia'
        },
        NE: {
          name_ar: 'النيجر',
          name_en: 'Niger'
        },
        PG: {
          name_ar: 'بابوا غينيا الجديدة',
          name_en: 'Papua New Guinea'
        },
        VC: {
          name_ar: 'سانت فنسنت وغرنادين',
          name_en: 'Saint Vincent and the Grenadines'
        },
        SO: {
          name_ar: 'الصومال',
          name_en: 'Somalia'
        },
        SZ: {
          name_ar: 'سوازيلاند',
          name_en: 'Swaziland'
        }
      }
    },
    groups: {
      group: {
        name: {
          ar: 'العالم',
          en: 'world'
        }
      },
      all: {
        WORLD: {
          name: {
            ar: 'العالم',
            en: 'world'
          }
        },
        ARAB: {
          name: {
            ar: 'العالم العربي',
            en: 'arab world'
          },
          list: ['DZ', 'MA', 'TN', 'LY', 'ME', 'EG', 'SD', 'DJ', 'SO', 'PS', 'OM', 'JO', 'YE', 'SA', 'AE', 'QA', 'KW', 'BH', 'IQ', 'SY', 'KM', 'LB']
        },
        AFRICA: {
          name: {
            ar: 'إفريقيا',
            en: 'Africa'
          },
          list: ['ZW', 'ZM', 'ZA', 'YT', 'UG', 'TZ', 'TN', 'TG', 'TD', 'SZ', 'ST', 'SO', 'SN', 'SL', 'SH', 'AC', 'SD', 'SC', 'RW', 'RE', 'NG', 'NE', 'NA', 'MZ', 'MW', 'MU', 'MR', 'ML', 'MG', 'MA', 'LY', 'LS', 'LR', 'KM', 'KE', 'GW', 'GQ', 'GN', 'GM', 'GH', 'GA', 'ET', 'ER', 'EG', 'DZ', 'DJ', 'CV', 'CM', 'CI', 'CG', 'CF', 'CD', 'BW', 'BJ', 'BI', 'BF', 'AO']
        },
        ASIA: {
          name: {
            ar: 'آسيا',
            en: 'Asia'
          },
          list: [
            'YE',
            'VN',
            'UZ',
            'TW',
            'TR',
            'TM',
            'TL',
            'TJ',
            'TH',
            'SY',
            'SG',
            'SA',
            'QA',
            'PW',
            'PS',
            'PK',
            'PH',
            'OM',
            'NP',
            'MY',
            'MV',
            'MO',
            'MN',
            'MM',
            'LK',
            'LB',
            'LA',
            'KZ',
            'KW',
            'KR',
            'KP',
            'KH',
            'KG',
            'JP',
            'JO',
            'IR',
            'IQ',
            'IO',
            'IN',
            'PS',
            'ID',
            'HK',
            'GE',
            'CY',
            'CX',
            'CN',
            'CC',
            'BT',
            'BN',
            'BH',
            'BD',
            'AZ',
            'AM',
            'AF',
            'AE'
          ]
        },
        EUROPE: {
          name: {
            ar: 'أوروبا',
            en: 'Europe'
          },
          list: [
            'VA',
            'UA',
            'SM',
            'SK',
            'SJ',
            'SI',
            'SE',
            'SU',
            'RU',
            'RS',
            'RO',
            'PT',
            'PL',
            'NO',
            'NL',
            'MT',
            'MK',
            'ME',
            'MD',
            'MC',
            'LV',
            'LU',
            'LT',
            'LI',
            'JE',
            'IT',
            'IS',
            'IM',
            'IE',
            'HU',
            'HR',
            'GR',
            'GI',
            'GG',
            'GB',
            'UK',
            'FR',
            'FO',
            'FI',
            'EU',
            'ES',
            'EE',
            'DK',
            'DE',
            'CZ',
            'CH',
            'BY',
            'BG',
            'BE',
            'BA',
            'AX',
            'AT',
            'AL',
            'AD'
          ]
        },
        OCEANIA: {
          name: {
            ar: 'أقيانوسيا',
            en: 'Oceania'
          },
          list: [
            'WS',
            'WF',
            'VU',
            'TV',
            'TO',
            'TK',
            'SB',
            'PN',
            'PG',
            'PF',
            'NZ',
            'NU',
            'NR',
            'NF',
            'NC',
            'MP',
            'MH',
            'KI',
            'GU',
            'FM',
            'FJ',
            'CK',
            'AU',
            'AS'
          ]
        },
        NORTHAMERICA: {
          name: {
            ar: 'أمريكا الشمالية',
            en: 'North America'
          },
          list: [
            'VI',
            'VG',
            'VC',
            'US',
            'TT',
            'TC',
            'SX',
            'SV',
            'PR',
            'PM',
            'PA',
            'NI',
            'MX',
            'MS',
            'MQ',
            'LC',
            'KY',
            'KN',
            'JM',
            'HT',
            'HN',
            'GT',
            'GP',
            'GL',
            'GD',
            'DM',
            'CW',
            'CU',
            'CR',
            'CA',
            'BZ',
            'BS',
            'AN',
            'BM',
            'BB',
            'AW',
            'AI',
            'AG'
          ]
        },
        SOUTHAMERICA: {
          name: {
            ar: 'أمريكا الجنوبية',
            en: 'South America'
          },
          list: [
            'VE',
            'UY',
            'SR',
            'PY',
            'PE',
            'GY',
            'GF',
            'FK',
            'EC',
            'DO',
            'CO',
            'CL',
            'BR',
            'BO',
            'AR'
          ]
        },
        ANTARCTICA: {
          name: {
            ar: 'أنتاركتيكا',
            en: 'Antarctica'
          },
          list: [
            'TF',
            'HM',
            'GS',
            'BV',
            'AQ'
          ]
        }

      }
    },
    countriesData: [],
    selectedCountry: null,
    selectedGroup: null,
    user: null,
    theme: 'dark'
  },
  mutations: {
    config (state, data) {
      try {
        if (data.country) {
          localStorage.country = data.country
          var countryData = state.countriesData.find(_country => _country.country.code === data.country.toUpperCase()) || null
          if (countryData) {
            state.selectedCountry = countryData
          }
        }
        if (data.group) {
          localStorage.group = data.group
          var groupData = state.groups.all[data.group.toUpperCase()] || null
          if (groupData) {
            state.groups.group = groupData
            state.selectedGroup = groupData
          }
          console.log(state.groups.all[data.group.toUpperCase()])
        }
        if (data.search) {
          state.search = data.search
        }
        if (data.locale) {
          localStorage.locale = data.locale
          i18n.locale = data.locale
        }
        if (data.theme) {
          localStorage.theme = data.theme
          state.theme = data.theme
        }
      } catch (error) {
        console.error(error)
      }
    },
    setGroup (state, groupData) {
      state.groups.group = groupData
    },
    setUserData (state, userData) {
      state.user = userData
    },
    setSelectedCountry (state, countryData) {
      state.selectedCountry = countryData
    },
    setCountriesData (state, countriesData) {
      var _countriesData = []
      var _dataCountry = []
      countriesData.forEach(country => {
        _dataCountry = Object.entries(state.countries.all).find(_country => _country[1].name_en.toUpperCase() === country.country.toUpperCase())
        if (_dataCountry) {
          country.country = {
            code: _dataCountry[0],
            ..._dataCountry[1]
          }
          _countriesData.unshift(country)
        }
      })
      state.selectedCountry = _countriesData[0]
      state.countriesData = _countriesData
    },
    updateCountriesData (state, countriesData) {
      var _countriesData = []
      var _dataCountry = []
      countriesData.forEach(country => {
        _dataCountry = Object.entries(state.countries.all).find(_country => _country[1].name_en.toUpperCase() === country.country.toUpperCase())
        if (_dataCountry) {
          country.country = {
            code: _dataCountry[0],
            ..._dataCountry[1]
          }
          _countriesData.unshift(country)
        }
      })
      state.countriesData = _countriesData
    },
    setMedia (state) {
      state.W = window.innerWidth
      state.H = window.innerHeight
    }
  },
  actions: {
    loadCountries ({ commit, state }, countries, orderBy = 'cases') {}
  },
  getters: {
    getCountryFlag: (state) => (country = 'none') => {
      try {
        return require('@/assets/flags/icons/' + country.country.code.toUpperCase() + '.svg')
      } catch (e) {
        return require('@/assets/flags/icons/_logo.svg')
      }
    },
    getSelectedCountries: (state) => (orderBy = 'cases', search = '') => {
      var _countries
      if (state.groups.group.list) {
        _countries = state.countriesData.filter(item => state.groups.group.list.includes(item.country.code))
      } else {
        _countries = state.countriesData
      }
      if (search !== '') {
        _countries = _countries.filter(_country => (_country.country.name_ar + _country.country.name_en + ' ' + _country.country.code).toUpperCase().includes(search.toUpperCase()))
      }
      var list = _countries.filter((x, index) => index <= (_countries.length)).sort((a, b) => {
        if (a[orderBy] < b[orderBy]) {
          return -1
        }
        if (a[orderBy] > b[orderBy]) {
          return 1
        }
        return 0
      })
      return list.reverse()
    },
    getSelectedCountriesTotal: (state, getters) => (orderBy = 'cases') => {
      const _o = prop => ([0, 0, ...getters.getSelectedCountries().map((_prop) => _prop[prop])]).reduce((a, b) => a + b)
      return {
        cases: getters.convertToNumberWithSuffix(_o('cases')),
        casesP: _o('casesPerOneMillion') + '/مليون',
        todayCases: _o('todayCases'),
        todayCasesP: ((_o('todayCases') / _o('cases') * 100).toFixed(1) * 1) + '%',
        //
        deaths: getters.convertToNumberWithSuffix(_o('deaths')),
        deathsP: ((_o('deaths') / _o('cases') * 100).toFixed(1) * 1) + '%',
        //
        todayDeaths: getters.convertToNumberWithSuffix(_o('todayDeaths')),
        todayDeathsP: ((_o('todayDeaths') / _o('todayCases') * 100).toFixed(1) * 1) + '%',
        //
        recovered: getters.convertToNumberWithSuffix(_o('recovered')),
        recoveredP: ((_o('recovered') / _o('cases') * 100).toFixed(1) * 1) + '%',
        //
        active: _o('active'),
        activeP: ((_o('active') / _o('cases') * 100).toFixed(1) * 1) + '%',
        //
        critical: _o('critical'),
        criticalP: ((_o('active') / _o('active') * 100).toFixed(1) * 1) + '%',
        //
        casesPerOneMillion: _o('casesPerOneMillion')
      }
    },
    isMedia: state => (screen = 's') => {
      var screens = {
        s: state.W <= 480,
        m: state.W > 480 && state.W <= 840,
        l: state.W > 840 && state.W <= 1201,
        xl: state.W > 1201
      }
      return screens[screen]
    },
    convertToNumberWithSuffix: (state) => (number) => {
      if (number > 1000000000) {
        return (number / 1000000000).toFixed(1) + 'b'
      } else if (number > 1000000) {
        return (number / 1000000).toFixed(1) + 'm'
      } else if (number > 1000) {
        return (number / 1000).toFixed(1) + 'k'
      } else {
        return number
      }
    }
  }
})
